import React from "react";
import Tab from "./Tab";

function Main(props) {
	// GET ARRAY OF KEYS OF TABS OBJECT
	const tabsArr = Object.keys(props.tabs);

	// TRANSFORM TABS OBJECT KEYS INTO TABS ARRAY WITH IDS
	const tabs = tabsArr.map((tabID) => {
		return Object.assign({ tabID }, props.tabs[tabID]);
	});
	return (
		<main className="Main">
			{/* COMPONENT MAP TABS */}
			{tabs.map((item, index) => {
				return (
					<Tab
						tabID={item.tabID}
						title={item.title}
						user={props.user}
						categories={item.categories}
						key={item.tabID}
						fetchFirebase={props.fetchFirebase}
					/>
				);
			})}
			<footer className="tab-footer-home">
				<p className="p-footer-home">Share this page:</p>
				<a
					className="link-footer-home"
					href={`https://bkz-src.com/browse/${props.userID}`}
				>{`https://bkz-src.com/browse/${props.userID}`}</a>
				<h3 className="h3-footer-home">{props.userName}</h3>
			</footer>
		</main>
	);
}

export default Main;
